import React from 'react'
import { Typography, IconButton, Box } from '@mui/material';
import { getTabData } from '../../../../helpers';
import InfoRoundedIcon from '@mui/icons-material/InfoRounded';
import { dataConstants } from '../../../../constants';
import ShareThis from '../../../_common/ShareThis';
import ChartItem from '../../../_common/Skeleton/chart';
import dynamic from 'next/dynamic';
const D3Chart = dynamic(() => import('../../../_common/D3Chart'),
  { loading: () => <ChartItem /> })
import CollapseCard from '../../CollapseCard';

const { ECO_SECTION_CODES } = dataConstants || {};

function RealGDPGrowth({ data, sumData, onChangeInfo, handleClick, getChartData, selectedInfo, themes }) {

  //real gdp growth
  const gdpGrowth = data && data.length > 0 ? data.find(d => d.section_code === ECO_SECTION_CODES.GLA_REAL_GDP) : undefined;
  const gdpGrowthChart = gdpGrowth && gdpGrowth.tabData && gdpGrowth.tabData ? getChartData(gdpGrowth.tabData, getTabData(sumData, gdpGrowth, ECO_SECTION_CODES.GLA_DATA)) : undefined;

  return (
    <>
      {gdpGrowth &&
        <Box component="div" className="col-md-4" sx={{ height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
          <Box
            className="section"
            sx={{
              display: 'flex',
              alignItems: 'center',
              mb: 1.4,
              px: 0.5,
            }}
          >
            <Typography component="h4" className="option-title" sx={{ mr: 'auto' }} >
              {gdpGrowth.section_name}
            </Typography>
            {/* <IconButton aria-label="info" onClick={() => onChangeInfo(gdpGrowth.section_code)} >
              <InfoRoundedIcon size="small" sx={{ fontSize: '1.2rem', color: 'text.link' }} />
            </IconButton> */}
            <ShareThis
              // link={url}
              link={encodeURI(`${process.env.NEXT_PUBLIC_URL}${dataConstants.NAVS.CHART_SHARE}/${gdpGrowthChart?.code}/${gdpGrowthChart?.series.map(d => d.yformula).join(';')}/${gdpGrowth.section_name}`)}
              title={`${gdpGrowth.section_name}`}
              message={`${gdpGrowth.section_name}`}
              subject={''}
            />
          </Box>
          {gdpGrowthChart && gdpGrowthChart.description &&
            <Box component="div" className="option-desc" sx={{ mb: 2, px: 2 }}>
              <Typography variant="caption" sx={{ color: 'text.description' }} dangerouslySetInnerHTML={{ __html: gdpGrowthChart.description }} />
            </Box>}
          <Box component="div">
            <Box component="div" className="option-content eco-chart" sx={{ position: 'relative', pr: 2, minHeight: '12rem' }}>
              <D3Chart
                showChart={true}
                noHeader
                // maxHeight={chartProps.maxHeight}
                scale={1}
                // onClick={code => handleClick(code)}
                chart={{ ...gdpGrowthChart, id: gdpGrowth.section_code, tick: 2 }}
                // userName={`@${chart.code.split('@')[1]}`}
                themes={themes}
                type={dataConstants.CHART_STATE.VIEW}
                // axisTextMargin={chartProps.axisTextMargin}
                chartMargin={{ left: 40, bottom: 48 }}
                axisTextMargin={{ y: 96 }}
                // wrapperClass="StockCardImage"
                //showLegend={false}
                showCrosshair
              />
            </Box>
            <CollapseCard
              selectedInfo={selectedInfo}
              section_code={gdpGrowth?.section_code}
              chart_codes={gdpGrowthChart}
              handleClick={handleClick}
            />
          </Box>
        </Box>}
    </>
  )
}

export default RealGDPGrowth
